var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M288.02,352.04v136.02c0,18.4,20.8,30.1,36.5,20.5l143.99-88.01c9.2-5.6,13.5-16.7,10.6-27.1-17-59.81-31.1-123.22-31.1-185.42,0-85.01-89.09-149.22-153.09-189.02-1.9-1.2-4-2.6-6.3-4.1h0c-9.4-6.5-21.9-14.9-32.6-14.9s-23.2,8.4-32.7,14.9c-2.3,1.5-4.4,3-6.3,4.1C153.13,58.81,64.03,123.02,64.03,208.03c0,62.21-14.1,125.62-31.1,185.42-3,10.4,1.4,21.4,10.6,27.1l143.99,88.01c15.7,9.6,36.5-2.1,36.5-20.5v-192.02h0v-28.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6,0-10.3,8.3-18.6,18.6-18.6h218.68c10.3,0,18.6,8.3,18.6,18.6,0,8-5.1,15.1-12.7,17.6l-72.3,24.1c-6.5,2.2-10.9,8.3-10.9,15.2v84.51h-.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnights);
export default __webpack_public_path__ + "static/media/knights.fc8ba7884530fae9f990bd0f3565b4f5.svg";
export { ForwardRef as ReactComponent };